"use client";

// packages/eden-table/src/components/TH.jsx
import { useContext } from "react";
import styled from "styled-components";
import {
  spacing16,
  backgroundColorLevelCurrent
} from "@churchofjesuschrist/eden-style-constants";
import OverflowWrapperContext from './OverflowWrapper/Context.js';
import StickyHeaderContext from './Table/StickyHeaderContext.js';
import {
  backgroundDef as fadeBackgroundDef,
  topBackground as fadeBackground,
  size as fadeSize
} from "@churchofjesuschrist/eden-fade";
import { jsx } from "react/jsx-runtime";
var Root = styled.th`
  ${fadeBackgroundDef};
  position: relative;
  text-align: ${({ $dataType }) => $dataType === "number" ? "end" : "start"};
  padding: calc(${spacing16} / var(--eden-table-density-divisor, 1));

  &[scope="col"] {
    z-index: 1;

    &::after {
      content: "";
      position: absolute;
      top: 1px;
      left: 0px;
      bottom: 1px;
      right: 0px;
      background-color: ${backgroundColorLevelCurrent};
      z-index: -1;
    }
    ${({ $stuck }) => $stuck ? `&::before {
        content: "";
        pointer-events: none;
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        height: ${fadeSize};
        // Matches top shadow from OverflowWrapper
        background: ${fadeBackground};
      }` : ""}
  }
`;
var TH = ({ children, scope, type, ariaSort, ...props }) => {
  const tableOverflowing = useContext(OverflowWrapperContext);
  const stickyHeader = useContext(StickyHeaderContext);
  return /* @__PURE__ */ jsx(
    Root,
    {
      ...props,
      scope,
      role: scope === "col" ? "columnheader" : "rowheader",
      "aria-sort": ariaSort,
      $dataType: type,
      $stuck: stickyHeader && tableOverflowing,
      children
    }
  );
};
TH.displayName = "TH";
var TH_default = TH;
export {
  TH_default as default
};
